import { getFontCss, styleConstants } from '@paywithextend/components'
import React from 'react'
import Box from 'src/components/Box/Box'
import { useTranslate } from 'src/localization/Trns'
import { CreditCardListModel } from 'src/models/creditCard.models'
import { css } from 'styled-components'

interface BudgetSummaryBoxProps {
  className?: string
  creditCard: CreditCardListModel
}
const BudgetSummaryBox: React.FC<BudgetSummaryBoxProps> = (
  props,
): React.ReactElement => {
  const translate = useTranslate()

  return (
    <Box
      noPadding
      css={css`
        height: 100%;
      `}
    >
      <div
        css={css`
          height: 100%;
          display: flex;
          flex-direction: column;
          border-top-left-radius: 10px;
          border-top-right-radius: 10px;
          border-bottom-left-radius: 10px;
          border-bottom-right-radius: 10px;
          background-image: linear-gradient(45deg, #697080 60%, #8e95a7 160%);
          padding: ${`40px 40px`};
        `}
      >
        <div
          css={css`
            display: flex;
            align-items: center;
            justify-content: space-between;
          `}
        >
          <div
            css={css`
              display: flex;
              align-items: flex-end;
            `}
          >
            <span
              css={css`
                ${getFontCss(
                  20,
                  styleConstants.colors.white,
                  styleConstants.fontFamilies.medium,
                )}
                font-weight: bold;
                line-height: 120%;
              `}
            >
              {translate('Budget Summary')}
            </span>
          </div>
        </div>
        <div
          css={css`
            margin-top: 28px;
          `}
        >
          <div
            css={css`
              padding-top: 15px;
            `}
          >
            <span
              css={css`
                font-size: 32px;
                color: #ffffff;
              `}
            >
              {translate('Inactive')}
            </span>
          </div>
          <div
            css={css`
              display: flex;
              flex-direction: column;
              justify-content: space-between;
              margin-top: 16px;
            `}
          >
            <span
              css={css`
                ${getFontCss(
                  14,
                  styleConstants.colors.white,
                  styleConstants.fontFamilies.regular,
                )};
                line-height: 128.6%;
              `}
            >
              {translate(
                'This budget has been inactive since ${inactiveSince}',
                {
                  inactiveSince:
                    props.creditCard.inactiveSinceTimezonedString || '',
                },
              )}
            </span>
          </div>
        </div>
      </div>
    </Box>
  )
}

export default BudgetSummaryBox
